import { useSelector, useDispatch } from "react-redux"
import ScheduleItem from "./ScheduleItem"
import { scheduleHover, projectActions } from "state_management"
import dragTypes from "utils/scripts/dragTypes"

export default function ScheduleAction({ actionId, shouldShowState, style, onClick, view, showIcons }) {
  const dispatch = useDispatch()
  const action = useSelector((state) => state.projectActions.plannedProjectActions[actionId])
  const isActive = useSelector((state) => action ? state.scheduleHover.projectId === action.projectId : false)
  const project = useSelector((state) => action ? state.projects[action.projectId] : null)
  const constraintChecks = useSelector((state) => state.constraintChecks[actionId]) || []
  const assets = useSelector((state) => state.asset.assets)
  
  // If action is not found in planned actions, it may have been unplanned
  if (!action || !project) {
    return null
  }
  
  return (
    <ScheduleItem
      item={action}
      backgroundColor={project.color}
      shouldShowState={shouldShowState}
      style={style}
      isActive={isActive}
      onMouseEnter={() => dispatch(scheduleHover.setProjectId(action.projectId))}
      onMouseLeave={() => dispatch(scheduleHover.setProjectId(null))}
      onClick={onClick}
      dragType={dragTypes.ACTION}
      name={project.singleActionProject ? action.name : `${project.name}: ${action.name}`}
      description={action.description}
      state={action.stage}
      constraintChecks={constraintChecks}
      movable={action.movable}
      setMovable={(movable) => dispatch(projectActions.setMovable(action.id, movable))}
      view={view}
      assetName={action.assetIds.length ? assets[action.assetIds[0]].name : ""}
      showIcons={showIcons}
    />
  )
}
